function checkRecaptcha(initOnScroll, search) {
	grecaptcha.ready(function () {
		grecaptcha.execute(tmscripts.recaptchaKey, { action: 'algolia' })
			.then(function (token) {
				jQuery.ajax({
					url: brookingsAlgolia.ajaxUrl,
					type: 'POST',
					data: {
						action: 'check_recaptcha',
						token: token
					}
				}).done(function (response) {
					if ( response.success ) {
						initOnScroll(search);
					} else {
						console.warn("Suspicious activity detected. Please try again later.");
					}
				});
			});
	});
}

export default checkRecaptcha;

